import React, { useState, useEffect } from 'react'

import classNames from 'classnames'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  checked?: boolean
  disabled?: boolean
  label?: string | JSX.Element
  name: string
  onChecked?: (val: boolean, e: React.ChangeEvent<HTMLInputElement>) => void
  right?: boolean
}

const Checkbox = React.forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
  const { className, checked, disabled, label, name, onChecked, right, value, tabIndex, ...rest } =
    props
  const [check, setCheck] = useState(checked)

  const toggle = (e) => {
    e.preventDefault()
    if (disabled) {
      return null
    }
    setCheck(!check)
    onChecked && onChecked(!check, e)
  }

  useEffect(() => {
    setCheck(checked)
  }, [checked])

  return (
    <label
      className={classNames('flex flex-row items-center', className)}
      onClick={(e) => toggle(e)}>
      {(right && label && <span className="mr-2">{label}</span>) || null}
      <div
        tabIndex={tabIndex}
        // toggle checkbox on press enter or space
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            toggle(e)
          }
        }}
        className={classNames(
          'flex flex-row items-center justify-center w-[14px] text-blue',
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        )}>
        {check ? <CheckedIcon /> : <UncheckedIcon />}
        <input
          {...rest}
          ref={ref}
          type="checkbox"
          name={name}
          checked={check}
          value={value}
          onChange={toggle}
          disabled={disabled}
          hidden
        />
      </div>
      {(!right && label && <span className="ml-2">{label}</span>) || null}
    </label>
  )
})
Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  right: false,
  name: '',
  className: '',
  tabIndex: 0,
}
export default Checkbox

const UncheckedIcon = () => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="1" width="11" height="11" rx="1" fill="white" stroke="#878B96" />
  </svg>
)

const CheckedIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 2.5C1 1.67157 1.67157 1 2.5 1H11.3502C12.1786 1 12.8502 1.67157 12.8502 2.5V11.5307C12.8502 12.3591 12.1786 13.0307 11.3502 13.0307H2.5C1.67157 13.0307 1 12.3591 1 11.5307V2.5Z"
      fill="currentColor"
    />
    <path d="M3 7.28069L6.44851 10.0307L10.8502 4" stroke="white" strokeWidth="1.5" />
    <path
      d="M2.5 1.5H11.3502V0.5H2.5V1.5ZM12.3502 2.5V11.5307H13.3502V2.5H12.3502ZM11.3502 12.5307H2.5V13.5307H11.3502V12.5307ZM1.5 11.5307V2.5H0.5V11.5307H1.5ZM2.5 12.5307C1.94771 12.5307 1.5 12.083 1.5 11.5307H0.5C0.5 12.6353 1.39543 13.5307 2.5 13.5307V12.5307ZM12.3502 11.5307C12.3502 12.083 11.9025 12.5307 11.3502 12.5307V13.5307C12.4548 13.5307 13.3502 12.6353 13.3502 11.5307H12.3502ZM11.3502 1.5C11.9025 1.5 12.3502 1.94771 12.3502 2.5H13.3502C13.3502 1.39543 12.4548 0.5 11.3502 0.5V1.5ZM2.5 0.5C1.39543 0.5 0.5 1.39543 0.5 2.5H1.5C1.5 1.94771 1.94771 1.5 2.5 1.5V0.5Z"
      fill="currentColor"
    />
  </svg>
)
